/**
 * Sprint 24 — ConnectionTypeChip.
 *
 * The small uppercase pill that labels a connection's type on list rows, detail
 * headers, the Add menu, and Equipped-with sub-text. First-party-ness dominates
 * the colour (Q9/Q10): a first-party wrapped API reads purple, like first-party
 * MCP. Single source of truth for the type→colour mapping (Q6).
 */

import type { CSSProperties } from "react";

export type ConnectionChipType = "mcp" | "mcp-first-party" | "wrapped" | "wrapped-first-party";

/** Ramp 50 (background) / ramp 800 (text) per type. Reused by `<ConnectionRow>` avatars. */
export const CONNECTION_CHIP_COLORS: Record<ConnectionChipType, { bg: string; fg: string; label: string }> = {
  mcp: { bg: "#FAEEDA", fg: "#854F0B", label: "MCP" },
  "mcp-first-party": { bg: "#EEEDFE", fg: "#3C3489", label: "MCP · 1ST" },
  wrapped: { bg: "#E1F5EE", fg: "#0F6E56", label: "WRAPPED" },
  "wrapped-first-party": { bg: "#EEEDFE", fg: "#3C3489", label: "WRAPPED · 1ST" },
};

export interface ConnectionTypeChipProps {
  type: ConnectionChipType;
  size?: "default" | "small";
}

export function ConnectionTypeChip({ type, size = "default" }: ConnectionTypeChipProps) {
  const c = CONNECTION_CHIP_COLORS[type];
  const style: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    fontSize: size === "small" ? 8 : 9,
    padding: size === "small" ? "1px 6px" : "2px 7px",
    borderRadius: 999,
    fontWeight: 500,
    letterSpacing: "0.3px",
    textTransform: "uppercase",
    background: c.bg,
    color: c.fg,
    fontFamily: "var(--font-sans)",
    lineHeight: 1.4,
    flexShrink: 0,
    whiteSpace: "nowrap",
  };
  return <span style={style}>{c.label}</span>;
}
